import { render, staticRenderFns } from "./subject-builder.view.vue?vue&type=template&id=680c0c9c&scoped=true&"
import script from "./subject-builder.view.ts?vue&type=script&lang=ts&"
export * from "./subject-builder.view.ts?vue&type=script&lang=ts&"
import style0 from "./subject-builder.view.scss?vue&type=style&index=0&id=680c0c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c0c9c",
  null
  
)

export default component.exports